import { CALCULATION_CYCLE_POLL_INTERVAL_MS } from "@/features/tuition/constants";
import { CalculationCycleStatus } from "@/openapi/generated";

type CalculationCycleLike = {
  status?: CalculationCycleStatus | null;
} | null | undefined;

export function isTuitionCalculationRunning(
  cycle: CalculationCycleLike,
  calculationStarted = false,
): boolean {
  if (!cycle?.status) return false;

  if (cycle.status === CalculationCycleStatus.Calculating) {
    return true;
  }

  return (
    cycle.status === CalculationCycleStatus.Pending && calculationStarted
  );
}

export function getCalculationCyclePollInterval(
  cycle: CalculationCycleLike,
): number | false {
  const status = cycle?.status;
  if (
    status === CalculationCycleStatus.Calculating ||
    status === CalculationCycleStatus.Syncing
  ) {
    return CALCULATION_CYCLE_POLL_INTERVAL_MS;
  }
  return false;
}
